<template>
  <div class="container">
    <el-card>
      <div slot="header">参数配置</div>
      <div style="height: 100%">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
          <el-tab-pane label="统一电价、水价配置" name="PRICE">
            <div>
              <el-button type="primary" icon="el-icon-finished" size="small" @click="priceSava">保存
              </el-button>
              <el-form ref="form" label-width="180px" size="small" style="margin-top: 15px" label-position="left">
                <el-row :gutter="10">
                  <el-col :span="5">
                    <el-form-item label="默认电价（元/kW·h）">
                      <el-input v-model="form.PRICE_ELECTRIC.dicValue" oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="electricServiceFeeLabel">
                      <el-input v-model="form.PRICE_ELECTRIC_SERVICE_FEE.dicValue" oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="electricServiceFeeCustomNameLabel">
                      <el-input v-model="form.PRICE_ELECTRIC_SERVICE_FEE_NAME.dicValue"  maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="electricServiceFeeIsShowLabel">
                      <el-checkbox v-model="
                                form
                                  .PRICE_ELECTRIC_SERVICE_FEE_SHOW
                                  .dicValue
                              " true-label="1" false-label="0"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="5">
                    <el-form-item label="默认水价（元/m³）">
                      <el-input v-model="form.PRICE_WATER.dicValue" oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="waterServiceFeeLabel">
                      <el-input v-model="form.PRICE_WATER_SERVICE_FEE.dicValue" oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="waterServiceFeeCustomNameLabel">
                      <el-input v-model="form.PRICE_WATER_SERVICE_FEE_NAME.dicValue"  maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item :label="waterServiceFeeIsShowLabel">
                      <el-checkbox v-model="
                                form
                                  .PRICE_WATER_SERVICE_FEE_SHOW
                                  .dicValue
                              " true-label="1" false-label="0"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row >
                  <el-col :span="5">
                    <el-form-item label="小程序账单是否显示">
                      <el-checkbox v-model="
                                form
                                  .PRICE_BILL_IS_SHOW
                                  .dicValue
                              " true-label="1" false-label="0"></el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统一告警阀值配置" name="LIMIT_METER">
            <div class="centerBox">
              <div class="basicParam" style="margin-right: 30px">
                <div class="title">电表告警阀值配置</div>
                <div>
                  <el-form ref="form" label-width="150px" size="small" style="margin-top: 15px">
                    <!-- <el-row :gutter="10">
                      <el-col :lg="12">
                        <el-form-item label="功率限值阀值（W）">
                          <el-input
                            v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_POWER_VALUE
                                .dicValue
                            "
                            oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="12">
                        <el-form-item label="提示信息" label-width="90px">
                          <el-input
                            v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_POWER_MSG
                                .dicValue
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <el-row :gutter="10">
                      <el-col :lg="12">
                        <el-form-item label="电压欠压阀值（V）">
                          <el-input v-model="
                              meterAlarmThreshold
                                .LIMIT_METER_BELOW_VOLTAGE_VALUE.dicValue
                            " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="12">
                        <el-form-item label="提示信息" label-width="90px">
                          <el-input v-model="
                              meterAlarmThreshold.LIMIT_METER_BELOW_VOLTAGE_MSG
                                .dicValue
                            "></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <!-- <el-row :gutter="10">
                      <el-col :lg="12">
                        <el-form-item label="过流阀值（A）">
                          <el-input
                            v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_CURRENT_VALUE
                                .dicValue
                            "
                            oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="12">
                        <el-form-item label="提示信息" label-width="90px">
                          <el-input
                            v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_CURRENT_MSG
                                .dicValue
                            "
                          ></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row> -->
                    <el-row :gutter="10">
                      <el-col :lg="12">
                        <el-form-item label="过压阀值（V）">
                          <el-input v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_VOLTAGE_VALUE
                                .dicValue
                            " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="12">
                        <el-form-item label="提示信息" label-width="90px">
                          <el-input v-model="
                              meterAlarmThreshold.LIMIT_METER_OVER_VOLTAGE_MSG
                                .dicValue
                            "></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div class="btns">
                    <el-button type="primary" @click="limitMeterSava">保存</el-button>
                  </div>
                </div>
              </div>
              <div class="basicParam" style="margin-right: 30px">
                <div class="title">水表告警阀值配置</div>
                <div>
                  <el-form ref="form" :model="waterMeterAlarmThreshold" label-width="150px" size="small" style="margin-top: 15px">
                    <el-row :gutter="10">
                      <el-col :lg="12">
                        <el-form-item label="水表电池欠压阀值(V)">
                          <el-input v-model="
                              waterMeterAlarmThreshold
                                .LIMIT_WATER_BELOW_VOLTAGE_VALUE.dicValue
                            " oninput="value=value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/\.{2,}/g,'.').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :lg="12">
                        <el-form-item label="提示信息" label-width="90px">
                          <el-input v-model="
                              waterMeterAlarmThreshold
                                .LIMIT_WATER_BELOW_VOLTAGE_MSG.dicValue
                            "></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div class="btns">
                    <el-button type="primary" @click="limitWaterSava">保存</el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统一电表欠费告警配置" name="ARREARS_METER">
            <div>
              <div>
                <el-button type="primary" @click="arrearsMeterSava" icon="el-icon-finished" size="small" style="margin-bottom: 10px">保存</el-button>
              </div>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-card>
                    <div slot="header">欠费告警策略一</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsMeter">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="电表账户余额告警限值1(元)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox v-model="
                                arrearsMeter
                                  .ARREARS_METER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">微信</el-checkbox>
                            <el-checkbox v-model="
                                arrearsMeter
                                  .ARREARS_METER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">短信</el-checkbox>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_ALARM_TIMES_WX
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " :maxlength="6"></el-input>

                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入60的倍数)" label-width="140px">
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " :maxlength="6"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入60的倍数)" label-width="140px">

                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card>
                    <div slot="header">欠费告警策略二</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsMeter">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="电表账户余额告警限值2(元)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox v-model="
                                arrearsMeter
                                  .ARREARS_METER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">微信</el-checkbox>
                            <el-checkbox v-model="
                                arrearsMeter
                                  .ARREARS_METER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">短信</el-checkbox>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_ALARM_TIMES_WX
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入60的倍数)" label-width="140px">
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入60的倍数)" label-width="140px">
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-row :gutter="10" style="margin-top: 15px">
                <el-col :span="12">
                  <el-card>
                    <div slot="header">赊账告警策略</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsMeter">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="电表账户允许赊账金额限值(元)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_METER_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsMeter.ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsMeter.ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_METER_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_METER_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="7">
                            <el-form-item label-width="0">
                              <el-button type="primary" icon="el-icon-finished" size="small" @click="addElectricArrearage">添加欠费统一推送手机号
                              </el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <!-- <el-row :gutter="10">
													<el-col :span="15">
														<el-form-item label="物业联系人电话">
															<el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_METER_ALARM_PHONE
                                    .dicValue
                                " :disabled="
                                  arrearsMeter.ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
														</el-form-item>
													</el-col>
												</el-row>
												<el-row :gutter="10">
													<el-col :span="15">
														<el-form-item label="财务联系人电话">
															<el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OVER_DRAFT_METER_ALARM_PHONE2
                                    .dicValue
                                " :disabled="
                                  arrearsMeter.ARREARS_METER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
														</el-form-item>
													</el-col>
												</el-row> -->
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card>
                    <div slot="header">拉闸策略</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsMeter">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="拉闸余额阀值(元)">
                              <el-input v-model="
                                  arrearsMeter
                                    .ARREARS_METER_AUTO_GATE_LIMIT_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsMeter.ARREARS_METER_AUTO_GATE_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsMeter.ARREARS_METER_AUTO_GATE_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="24" :offset="0">
                            <el-form-item label="拉合闸验证方式">
                              <el-radio v-model="arrearsMeter.ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue" label="1">验证码</el-radio>
                              <el-radio v-model="arrearsMeter.ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue" label="0">密码</el-radio>
                              <el-input v-if="
                                  arrearsMeter.ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD
                                    .dicValue == '0'
                                    ? true
                                    : false" v-model="
                                  arrearsMeter
                                    .ARREARS_METER_OPEN_CLOSE_PASSWORD
                                    .dicValue" oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') " type="password" style="width:100px !important" placeholder="请输入密码" >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统一水表欠费告警配置" name="ARREARS_WATER">
            <div>
              <div>
                <el-button type="primary" @click="arrearsWaterSava" icon="el-icon-finished" size="small" style="margin-bottom: 10px">保存</el-button>
              </div>
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-card>
                    <div slot="header">欠费告警策略一</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsWater">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="水表账户余额告警限值1(元)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^\-0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox v-model="
                                arrearsWater
                                  .ARREARS_WATER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">微信</el-checkbox>
                            <el-checkbox v-model="
                                arrearsWater
                                  .ARREARS_WATER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">短信</el-checkbox>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_ALARM_TIMES_WX
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " :maxlength="6"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入1440的倍数)" label-width="160px">

                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " :maxlength="6"></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入1440的倍数)" label-width="160px">

                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card>
                    <div slot="header">欠费告警策略二</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsWater">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="水表账户余额告警限值2(元)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox v-model="
                                arrearsWater
                                  .ARREARS_WATER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">微信</el-checkbox>
                            <el-checkbox v-model="
                                arrearsWater
                                  .ARREARS_WATER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                  .dicValue
                              " true-label="1" false-label="0">短信</el-checkbox>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_ALARM_TIMES_WX
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="微信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_WX_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入1440的倍数)" label-width="160px">

                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="(只能输入1440的倍数)" label-width="160px">

                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-row :gutter="10" style="margin-top: 15px">
                <el-col :span="12">
                  <el-card>
                    <div slot="header">赊账告警策略</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsWater">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="水表账户允许赊账金额限值(元)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_WATER_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsWater.ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsWater.ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送次数设置(次)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_WATER_ALARM_TIMES_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="短信推送间隔时间设置(分钟)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS
                                    .dicValue
                                " :disabled="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="7">
                            <el-form-item label-width="0">
                              <el-button type="primary" icon="el-icon-finished" size="small" @click="addWaterArrearage">添加欠费统一推送手机号
                              </el-button>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <!-- <el-row :gutter="10">
													<el-col :span="15">
														<el-form-item label="物业联系人电话">
															<el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_WATER_ALARM_PHONE
                                    .dicValue
                                " :disabled="
                                  arrearsWater.ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
														</el-form-item>
													</el-col>
												</el-row>
												<el-row :gutter="10">
													<el-col :span="15">
														<el-form-item label="财务联系人电话">
															<el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_OVER_DRAFT_WATER_ALARM_PHONE2
                                    .dicValue
                                " :disabled="
                                  arrearsWater.ARREARS_WATER_OVER_DRAFT_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') "></el-input>
														</el-form-item>
													</el-col>
												</el-row> -->
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card>
                    <div slot="header">拉闸策略</div>
                    <div>
                      <el-form ref="form" label-width="220px" size="small" style="margin-top: 15px" :model="arrearsMeter">
                        <el-row :gutter="10">
                          <el-col :span="15">
                            <el-form-item label="拉闸余额阀值(元)">
                              <el-input v-model="
                                  arrearsWater
                                    .ARREARS_WATER_AUTO_GATE_LIMIT_VALUE
                                    .dicValue
                                " :disabled="
                                  arrearsWater.ARREARS_WATER_AUTO_GATE_SWITCH
                                    .dicValue == 0
                                    ? true
                                    : false
                                " oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') ">
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <div class="switch">
                              <el-switch style="display: block" v-model="
                                  arrearsWater.ARREARS_WATER_AUTO_GATE_SWITCH
                                    .dicValue
                                " active-text="开启" inactive-text="关闭" active-value="1" inactive-value="0">
                              </el-switch>
                            </div>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="24" :offset="0">
                            <el-form-item label="拉合闸验证方式">
                              <el-radio v-model="arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue" label="1">验证码</el-radio>
                              <el-radio v-model="arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue" label="0">密码</el-radio>
                              <el-input v-if="
                                  arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD
                                    .dicValue == '0'
                                    ? true
                                    : false" v-model="
                                  arrearsWater
                                    .ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD
                                    .dicValue" oninput="value=value.replace(/[^-\d]+/g, '').replace(/^0+(\d)/, '$1').replace('-', '$#$').replace(/\-/g, '').replace('$#$', '-').replace(/^(\d+)(\-)(\d?)$/, '$2$1$3') " type="password" style="width:100px !important" placeholder="请输入密码">
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-form>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值次数限制" name="CHARGE_LIMIT_TIMES">
            <div>
              <el-button type="primary" icon="el-icon-finished" size="small" @click="rechargeLimitSava">保存
              </el-button>
              <el-form ref="form" label-width="150px" size="small" style="margin-top: 15px">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="电费充值限制(次)">
                      <el-input v-model="rechargeLimit.CHARGE_LIMIT_TIMES_METER.dicValue" oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item label="水费充值限制(次)">
                      <el-input v-model="rechargeLimit.CHARGE_LIMIT_TIMES_WATER.dicValue" oninput="value=value.replace(/[^\d]+/g, '').replace(/^0+(\d)/, '$1') " maxlength="8"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-dialog :title="cardDialogTitle" :visible.sync="cardDialogVisible" width="800px">
        <el-button type="primary" icon="el-icon-plus" size="small" style="background-color: #1c84c6 !important;margin-left: 0 !important;" @click="addPhone()" :disabled="addShow">添加
        </el-button>
        <div class="tableStyle">
          <el-table :data="tableData" ref="nbCardInfoTable" style="width: 100%" height="90%" id="nbRecordTable">
            <el-table-column prop="phone" label="手机号" width="" align="center">
              <template slot-scope="scope">
                <input v-model="scope.row.phone" clearable :disabled="scope.row.buttonType == null" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="300px">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" class="iconfont" @click="removePhone(scope.row)" icon="el-icon-remove" style="background-color: #ed5565 !important;color: white !important;" v-if="scope.row.buttonType == null">移除手机号
                </el-button>
                <el-button size="mini" type="primary" class="iconfont" @click="tableDataBlur(scope.row)" icon="el-icon-finished" style="background-color: #1c84c6 !important;color: white !important;" v-if="scope.row.buttonType == 1">保存手机号
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cardDialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  selectTreeList,
  detail,
  sava,
  arrearsAlarmPropertyCommonPushManMeterSelectList,
  arrearsAlarmPropertyCommonPushManMeterSava,
  arrearsAlarmPropertyCommonPushManMeterRemove,
  arrearsAlarmPropertyCommonPushManWaterSelectList,
  arrearsAlarmPropertyCommonPushManWaterSava,
  arrearsAlarmPropertyCommonPushManWaterRemove,
} from '../../api/property/paramsManage';
import md5 from 'js-md5';
export default {
  data () {
    return {
      form: {
        PRICE_ELECTRIC: {},
        PRICE_WATER: {},
        PRICE_ELECTRIC_SERVICE_FEE: {},
        PRICE_WATER_SERVICE_FEE: {},
        PRICE_ELECTRIC_SERVICE_FEE_NAME: {},
        PRICE_WATER_SERVICE_FEE_NAME: {},
        PRICE_ELECTRIC_SERVICE_FEE_SHOW: {},
        PRICE_WATER_SERVICE_FEE_SHOW: {},
        PRICE_BILL_IS_SHOW: {}
      },

      arrearsMeter: {
        ARREARS_METER_STRATEGY_LIMIT1_SWITCH: {},
        ARREARS_METER_STRATEGY_LIMIT1_VALUE: {},
        ARREARS_METER_STRATEGY_LIMIT1_ALARM_TIMES_WX: {},
        ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX: {},
        ARREARS_METER_STRATEGY_LIMIT1_ALARM_TIMES_SMS: {},
        ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS: {},
        ARREARS_METER_STRATEGY_LIMIT1_WX_PUSH_SWITCH: {},
        ARREARS_METER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH: {},

        ARREARS_METER_STRATEGY_LIMIT2_SWITCH: {},
        ARREARS_METER_STRATEGY_LIMIT2_VALUE: {},
        ARREARS_METER_STRATEGY_LIMIT2_ALARM_TIMES_WX: {},
        ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX: {},
        ARREARS_METER_STRATEGY_LIMIT2_ALARM_TIMES_SMS: {},
        ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS: {},
        ARREARS_METER_STRATEGY_LIMIT2_WX_PUSH_SWITCH: {},
        ARREARS_METER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH: {},

        ARREARS_METER_OVER_DRAFT_SWITCH: {},
        ARREARS_METER_OVER_DRAFT_METER_VALUE: {},
        ARREARS_METER_OVER_DRAFT_METER_ALARM_PHONE: {},
        ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD: {},
        ARREARS_METER_OPEN_CLOSE_PASSWORD: {},

        ARREARS_METER_AUTO_GATE_SWITCH: {},
        ARREARS_METER_AUTO_GATE_LIMIT_VALUE: {},
        ARREARS_METER_OVER_DRAFT_METER_ALARM_PHONE2: {},

        ARREARS_METER_OVER_DRAFT_METER_ALARM_TIMES_SMS: {},
        ARREARS_METER_OVER_DRAFT_METER_ALARM_INTERVAL_SMS: {},
      },
      arrearsWater: {
        ARREARS_WATER_STRATEGY_LIMIT1_SWITCH: {},
        ARREARS_WATER_STRATEGY_LIMIT1_VALUE: {},
        ARREARS_WATER_STRATEGY_LIMIT1_ALARM_TIMES_WX: {},
        ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX: {},
        ARREARS_WATER_STRATEGY_LIMIT1_ALARM_TIMES_SMS: {},
        ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS: {},
        ARREARS_WATER_STRATEGY_LIMIT1_WX_PUSH_SWITCH: {},
        ARREARS_WATER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH: {},

        ARREARS_WATER_STRATEGY_LIMIT2_SWITCH: {},
        ARREARS_WATER_STRATEGY_LIMIT2_VALUE: {},
        ARREARS_WATER_STRATEGY_LIMIT2_ALARM_TIMES_WX: {},
        ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX: {},
        ARREARS_WATER_STRATEGY_LIMIT2_ALARM_TIMES_SMS: {},
        ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS: {},
        ARREARS_WATER_STRATEGY_LIMIT2_WX_PUSH_SWITCH: {},
        ARREARS_WATER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH: {},

        ARREARS_WATER_OVER_DRAFT_SWITCH: {},
        ARREARS_WATER_OVER_DRAFT_WATER_VALUE: {},
        ARREARS_WATER_OVER_DRAFT_WATER_ALARM_PHONE: {},

        ARREARS_WATER_AUTO_GATE_SWITCH: {},
        ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD: {},
        ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD: {},
        ARREARS_WATER_AUTO_GATE_LIMIT_VALUE: {},
        ARREARS_WATER_OVER_DRAFT_WATER_ALARM_PHONE2: {},

        ARREARS_WATER_OVER_DRAFT_WATER_ALARM_TIMES_SMS: {},
        ARREARS_WATER_OVER_DRAFT_WATER_ALARM_INTERVAL_SMS: {},
      },
      meterAlarmThreshold: {
        LIMIT_METER_OVER_POWER_VALUE: {},
        LIMIT_METER_OVER_POWER_MSG: {},
        LIMIT_METER_BELOW_VOLTAGE_VALUE: {},
        LIMIT_METER_BELOW_VOLTAGE_MSG: {},
        LIMIT_METER_OVER_CURRENT_VALUE: {},
        LIMIT_METER_OVER_CURRENT_MSG: {},
        LIMIT_METER_OVER_VOLTAGE_VALUE: {},
        LIMIT_METER_OVER_VOLTAGE_MSG: {},
      },
      waterMeterAlarmThreshold: {
        LIMIT_WATER_BELOW_VOLTAGE_VALUE: {},
        LIMIT_WATER_BELOW_VOLTAGE_MSG: {},
      },
      rechargeLimit: {
        CHARGE_LIMIT_TIMES_METER: {},
        CHARGE_LIMIT_TIMES_WATER: {}
      },
      activeName: 'PRICE',
      requestName: 'PRICE',
      powerLimit: '过载告警',
      voltageUnder: '欠压告警',
      overcurrent: '过流告警',
      Overpressure: '过压告警',
      waterVoltageUnder: '电池欠压告警',
      electricWarnDialogVisible: false,
      waterWarnDialogVisible: false,
      // 查询参数
      queryParams: {
        current: 1,
        size: 100,
        name: '',
        code: '',
      },
      areaTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      lesseeIdOptions: [],
      filterText: '',
      cardDialogTitle: '',
      cardDialogVisible: false,
      tableData: [],
      addShow: false,
      md5MeterPassword: '',
      md5WaterMeterPassword: '',
      electricServiceFeeLabel: '',
      electricServiceFeeCustomNameLabel: '',
      electricServiceFeeIsShowLabel: '',
      waterServiceFeeLabel: '',
      waterServiceFeeCustomNameLabel: '',
      waterServiceFeeIsShowLabel: '',
    };
  },
  created () {
    this.electricServiceFeeLabel = this.$root.serviceFeeNameElectric + "价格（元/kW·h）";
    this.electricServiceFeeCustomNameLabel = this.$root.serviceFeeNameElectric + "自定义名称";
    this.electricServiceFeeIsShowLabel = this.$root.serviceFeeNameElectric + "是否显示";
    this.waterServiceFeeLabel = this.$root.serviceFeeNameWater + "价格（元/m³）";
    this.waterServiceFeeCustomNameLabel = this.$root.serviceFeeNameWater +"自定义名称";
    this.waterServiceFeeIsShowLabel = this.$root.serviceFeeNameWater + "是否显示";
    this.init();
  },
  mounted () { },
  watch: {},
  methods: {
    async init () {
      await this.detail();
      await this.getSelectTreeList();
    },
    async handleClick (tab) {
      this.requestName = tab.name;
      if (tab.name == 'PRICE') {
        await this.detail();
      } else if (tab.name == 'LIMIT_METER') {
        await this.meterAlarmThresholdDetail();
        let tabName = 'LIMIT_WATER';
        this.requestName = tabName;
        await this.waterMeterAlarmThresholdDetail();
      } else if (tab.name == 'ARREARS_METER') {
        await this.arrearsMeterDetail();
      } else if (tab.name == 'ARREARS_WATER') {
        await this.arrearsWaterDetail();
      } else if (tab.name == "CHARGE_LIMIT_TIMES") {
        await this.rechargeLimitDetail();
      }
    },
    // 点击添加电费欠费同意推送手机号按钮
    async addElectricArrearage () {
      await this.arrearsAlarmPropertyCommonPushManMeterSelectList();
      this.cardDialogVisible = true;
      this.cardDialogTitle = '电账户欠费报警物业统一推送人信息';
    },
    async addWaterArrearage () {
      await this.arrearsAlarmPropertyCommonPushManWaterSelectList();
      this.cardDialogVisible = true;
      this.cardDialogTitle = '水账户欠费报警物业统一推送人信息';
    },
    // 电账户欠费报警物业统一推送人信息列表查询
    async arrearsAlarmPropertyCommonPushManMeterSelectList () {
      let res = await arrearsAlarmPropertyCommonPushManMeterSelectList().then()
      this.addShow = false;
      if (res.data == undefined || res.data == null) {
        this.tableData = [];
      } else {
        this.tableData = res.data;
      }
    },
    // 水账户欠费报警物业统一推送人信息列表查询
    async arrearsAlarmPropertyCommonPushManWaterSelectList () {
      let res = await arrearsAlarmPropertyCommonPushManWaterSelectList().then()
      this.addShow = false;
      if (res.data == undefined || res.data == null) {
        this.tableData = [];
      } else {
        this.tableData = res.data;
      }
    },
    // 删除电账户欠费报警物业统一推送人信息
    removePhone (row) {
      this.$confirm('确定要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        if (this.cardDialogTitle == '电账户欠费报警物业统一推送人信息') {
          await this.arrearsAlarmPropertyCommonPushManMeterRemove(row);
          await this.arrearsAlarmPropertyCommonPushManMeterSelectList();
          this.msgSuccess('删除成功');
        } else {
          await this.arrearsAlarmPropertyCommonPushManWaterRemove(row);
          await this.arrearsAlarmPropertyCommonPushManWaterSelectList();
          this.msgSuccess('删除成功');
        }
      });
    },
    // 欠费报警物业同意推送人信息鼠标保存手机号
    async tableDataBlur (row) {
      if (this.cardDialogTitle == '电账户欠费报警物业统一推送人信息') {
        await this.arrearsAlarmPropertyCommonPushManMeterSava(row);
        this.msgSuccess('保存成功');
        await this.arrearsAlarmPropertyCommonPushManMeterSelectList();
      } else {
        await this.arrearsAlarmPropertyCommonPushManWaterSava(row);
        this.msgSuccess('保存成功');
        await this.arrearsAlarmPropertyCommonPushManWaterSelectList();
      }
    },
    // 弹出框添加按钮
    addPhone () {
      this.addShow = true;
      let data = {
        phone: '',
        buttonType: 1,
      }
      this.tableData.push(data);
    },
    // 电账户统一欠费手机号保存
    async arrearsAlarmPropertyCommonPushManMeterSava (row) {
      await arrearsAlarmPropertyCommonPushManMeterSava(row).then();
    },
    // 电账户欠费报警物业统一推送人信息删除
    async arrearsAlarmPropertyCommonPushManMeterRemove (row) {
      await arrearsAlarmPropertyCommonPushManMeterRemove(row.id).then();
    },
    // 水账户统一欠费手机号保存
    async arrearsAlarmPropertyCommonPushManWaterSava (row) {
      await arrearsAlarmPropertyCommonPushManWaterSava(row).then();
    },
    // 水账户欠费报警物业统一推送人信息删除
    async arrearsAlarmPropertyCommonPushManWaterRemove (row) {
      await arrearsAlarmPropertyCommonPushManWaterRemove(row.id).then();
    },
    // 统一电价、水价配置保存
    async priceSava () {
      await sava(this.form).then();
      this.msgSuccess('保存成功');
      await this.detail();
    },
    // 统一告警阈值电表配置保存
    async limitMeterSava () {
      await sava(this.meterAlarmThreshold).then();
      this.msgSuccess('保存成功');
      this.requestName = 'LIMIT_METER';
      await this.meterAlarmThresholdDetail();
    },
    // 统一告警阈值水表配置保存
    async limitWaterSava () {
      await sava(this.waterMeterAlarmThreshold).then();
      this.msgSuccess('保存成功');
      let tabName = 'LIMIT_WATER';
      this.requestName = tabName;
      await this.waterMeterAlarmThresholdDetail();
    },
    // 统一电表欠费告警配置保存
    async arrearsMeterSava () {
      if (
        this.arrearsMeter.ARREARS_METER_OVER_DRAFT_METER_VALUE.dicValue <= 0
      ) {
        this.$message.error('赊账金额必须大于0元');
        return;
      }
      if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_WX_PUSH_SWITCH.dicValue == 1) {
        if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX.dicValue % 60 != 0 || this
          .arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX.dicValue == 0) {
          this.$message.error('微信推送间隔时间必须为60的倍数');
          return;
        }
      }
      if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH.dicValue == 1) {
        if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS.dicValue % 60 != 0 || this
          .arrearsMeter.ARREARS_METER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS.dicValue == 0) {
          this.$message.error('短信推送间隔时间必须为60的倍数');
          return;
        }
      }

      if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_WX_PUSH_SWITCH.dicValue == 1) {
        if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX.dicValue % 60 != 0 || this
          .arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX.dicValue == 0) {
          this.$message.error('微信推送间隔时间必须为60的倍数');
          return;
        }
      }
      if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH.dicValue == 1) {
        if (this.arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS.dicValue % 60 != 0 || this
          .arrearsMeter.ARREARS_METER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS.dicValue == 0) {
          this.$message.error('短信推送间隔时间必须为60的倍数');
          return;
        }
      }
      if (this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue == '0') {
        if (this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_PASSWORD.dicValue == '') {
          this.$message.error('请输入拉合闸验证密码');
          return;
        } else {
          if (this.md5MeterPassword != this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_PASSWORD.dicValue) {
            this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_PASSWORD.dicValue = md5(this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_PASSWORD.dicValue);
          }

        }
      }

      await sava(this.arrearsMeter).then();
      this.msgSuccess('保存成功');
      await this.arrearsMeterDetail();
    },
    // 统一水表欠费告警配置保存
    async arrearsWaterSava () {
      if (
        this.arrearsWater.ARREARS_WATER_OVER_DRAFT_WATER_VALUE.dicValue <= 0
      ) {
        this.$message.error('赊账金额必须大于0元');
        return;
      }
      if (this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_WX_PUSH_SWITCH.dicValue == 1) {
        if (
          this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX.dicValue == 0 || this
            .arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_WX.dicValue % 1440 != 0
        ) {
          this.$message.error('微信推送间隔时间必须为1440的倍数');
          return;
        }
      }
      if (this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_SMS_PUSH_SWITCH.dicValue == 1) {
        if (
          this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS.dicValue == 0 || this
            .arrearsWater.ARREARS_WATER_STRATEGY_LIMIT1_ALARM_INTERVAL_SMS.dicValue % 1440 != 0
        ) {
          this.$message.error('短信推送间隔时间必须为1440的倍数');
          return;
        }
      }
      if (this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_WX_PUSH_SWITCH.dicValue == 1) {
        if (
          this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX.dicValue == 0 || this
            .arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_WX.dicValue % 1440 != 0
        ) {
          this.$message.error('微信推送间隔时间必须为1440的倍数');
          return;
        }
      }
      if (this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_SMS_PUSH_SWITCH.dicValue == 1) {
        if (
          this.arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS.dicValue == 0 || this
            .arrearsWater.ARREARS_WATER_STRATEGY_LIMIT2_ALARM_INTERVAL_SMS.dicValue % 1440 != 0
        ) {
          this.$message.error('短信推送间隔时间必须为1440的倍数');
          return;
        }
      }

      if (this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_SWITCH_METHOD.dicValue == '0') {
        if (this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD.dicValue == '') {
          this.$message.error('请输入拉合闸验证密码');
          return;
        } else {
          if (this.md5WaterMeterPassword != this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD.dicValue) {
            this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD.dicValue = md5(this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD.dicValue);
          }
        }
      }

      await sava(this.arrearsWater).then();
      this.msgSuccess('保存成功');
      await this.arrearsWaterDetail();
    },
    async rechargeLimitSava () {
      await sava(this.rechargeLimit).then();
      this.msgSuccess('保存成功');
      await this.rechargeLimitDetail();
    },
    // 查询
    async detail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.form = res.data;
    },
    // 电表告警阀值配置查询
    async meterAlarmThresholdDetail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.meterAlarmThreshold = res.data;
    },
    // 水表告警阀值配置查询
    async waterMeterAlarmThresholdDetail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.waterMeterAlarmThreshold = res.data;
    },
    // 电表欠费告警配置查询
    async arrearsMeterDetail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.arrearsMeter = res.data;
      this.md5MeterPassword = this.arrearsMeter.ARREARS_METER_OPEN_CLOSE_PASSWORD.dicValue;
    },
    // 水表欠费告警配置查询
    async arrearsWaterDetail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.arrearsWater = res.data;
      this.md5WaterMeterPassword = this.arrearsWater.ARREARS_WATER_METER_OPEN_CLOSE_PASSWORD.dicValue;
    },
    // 充值限制查询
    async rechargeLimitDetail () {
      let data = {
        paramPrefix: this.requestName,
      };
      let res = await detail(data).then();
      this.rechargeLimit = res.data;
    },
    // 单一 电表 告警配置 告警阀值设置
    electricWarndataSet () {
      this.electricWarnDialogVisible = true;
    },
    // 单一 水表 告警配置 告警阀值设置
    waterWarndataSet () {
      this.waterWarnDialogVisible = true;
    },
    // 获取区域 tree
    async getSelectTreeList () {
      const res = await selectTreeList().then();
      this.areaTreeData = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  display: flex;
  flex-wrap: wrap;
}

.el-card {
  min-width: 100%;
  height: 100%;
  transition: all 0.5s;
}

/deep/.el-card__body {
  padding: 15px !important;
}

.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-form-item {
  display: inline-block;
  margin-bottom: 10px;
  width: 100%;

  .el-input {
    width: 100% !important;
  }
}

.searchTag {
  width: 200px;
}

/deep/ .el-tabs {
  height: 100% !important;
}

.el-button {
  margin-left: 10px;
}

.centerBox {
  width: 95%;
  margin: 0 auto;
  display: flex;
}

.basicParam {
  width: 50%;
  border-radius: 5px;
  box-shadow: 0px 0px 4px 2px #ccc;
  margin-top: 15px;
  padding: 20px;
  position: relative;

  .title {
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #ccc;
  }

  .el-form {
    margin-bottom: 50px;
  }

  .btns {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
  }
}

.switch {
  position: relative;
  // text-align: center;
}

/* switch按钮样式 */
.switch /deep/ .el-switch__label {
  position: absolute;
  display: none;
  color: rgb(250, 250, 250);
}

/*打开时文字位置设置*/
.switch /deep/ .el-switch__label--right {
  z-index: 1;
  left: 0px;
  top: 0px;
}

/*关闭时文字位置设置*/
.switch /deep/ .el-switch__label--left {
  z-index: 1;
  left: 20px;
  top: 0;
}

/*显示文字*/
.switch /deep/ .el-switch__label.is-active {
  display: block !important;
}

/* 调整按钮的宽度 */
.switch /deep/ .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px !important;
  height: 30px;
}

/deep/ .el-switch__core:after {
  top: 5px !important;
}

/deep/ .el-switch__label span {
  line-height: 30px;
}

.tableStyle {
  height: 500px;
  overflow: auto;
  margin-top: 10px;

  /deep/.el-input__inner {
    border: 0px !important;
    text-align: center !important;
  }

  input {
    border: 0px !important;
    text-align: center !important;
    width: 100%;
    height: 100%;
    -webkit-appearance: none;
    background-image: none;
    border-radius: 4px;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
}
</style>
